import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useAuth } from '../../auth/auth';
import Profile from './Profile/Profile';
import { Tab, Tabs } from '@mui/material';
import Gradings from './GradingsRate/Gradings';
import { getWorkerProfile } from '../../api/apiCall';
import { useSearchParams } from 'react-router-dom';
import AccessDenied from '../../components/Access/AccessDenied';
import Loading from '../../components/Loading/Loading';
import ContactHistory from './Profile/Contact History/ContactHistory';
import Safety from './Safety/Safety';
import Reference from './Profile/ReferenceForm/Reference';
import WorkHistory from './Profile/WorkHistory/WorkHistory';
import OnboardingForms from './Profile/OnboardingForms/OnboardingForms';
import Ticket from './Profile/Tickets/Tickets';
import Competencies from './Profile/CompetenciesV2/Competencies';
import Holiday from './Profile/Holiday/Holiday';

function CustomTabPanel(props: any) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ProfileTab = () => {
  const {state} = useAuth();
  const [value, setValue] = useState(0);
  const [searchParams, ] = useSearchParams();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profileInfo, setProfileInfo] = useState<any>();

  const handleChange = (_: any, newValue: any) => {
    setValue(newValue)
  };

  const getWorkerInfo = async () => {
    try {
      const response = await getWorkerProfile(state.user?.token, searchParams.get('workerId'));
      if(!response?.data.success) {
        setIsAdmin(true);
        setLoading(false);
      }
      if(response?.status === 200) {
        setProfileInfo(response?.data.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getWorkerInfo();
  }, [])

  if(loading) {
    return <Loading backgroundColor="#f2f5fc" />
  }

  if(isAdmin) {
    return <AccessDenied />;
  }

  return (
    <Box
      sx={{
        pt: 2,
        bgcolor: "#f2f5fc"
      }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider"
        }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Profile" {...a11yProps(0)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Tickets (old)" {...a11yProps(1)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Competencies (new)" {...a11yProps(2)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Onboarding Forms" {...a11yProps(3)} />
           <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Reference form" {...a11yProps(4)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Work History" {...a11yProps(5)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Gradings" {...a11yProps(6)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Safety" {...a11yProps(7)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Holiday" {...a11yProps(8)} />
          {profileInfo.callHistories && profileInfo.callHistories.length > 0 &&
            <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Contact History" {...a11yProps(9)} />
          }
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <Profile 
          profileInfo={profileInfo}
          setProfileInfo={setProfileInfo}
          getWorkerInfo={getWorkerInfo}
        />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <Box
          sx={{
            margin: "auto",
            padding: 3,
            background: "#fff",
            marginTop: 5,
            border: "1px solid rgb(236, 236, 236)",
          }}
        >
          <Ticket profileInfo={profileInfo} getWorkerInfo={getWorkerInfo} />
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <Box
          sx={{
            margin: "auto",
            padding: 3,
            background: "#fff",
            marginTop: 5,
            border: "1px solid rgb(236, 236, 236)",
          }}
        >
          <Competencies profileInfo={profileInfo} getWorkerInfo={getWorkerInfo} />
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>
        <Box
          sx={{
            margin: "auto",
            padding: 3,
            background: "#fff",
            marginTop: 5,
            border: "1px solid rgb(236, 236, 236)",
          }}
        >
          <OnboardingForms profileInfo={profileInfo} getWorkerInfo={getWorkerInfo} />
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <Reference
          profileInfo={profileInfo}
          getWorkerInfo={getWorkerInfo}
         />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={5}>
        <WorkHistory />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={6}>
        <Gradings />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={7}>
        <Safety />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={8}>
        <Box
          sx={{
            margin: "auto",
            padding: 3,
            background: "#fff",
            marginTop: 5,
            border: "1px solid rgb(236, 236, 236)",
          }}
        >
          <Holiday
            profileInfo={profileInfo}
            getWorkerInfo={getWorkerInfo}
          />
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={9}>
        <ContactHistory
          profileInfo={profileInfo}
          getWorkerInfo={getWorkerInfo}
        />
      </CustomTabPanel>
    </Box>
  );
}

export default ProfileTab;
